import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  Typography,
  CircularProgress,
  Paper,
} from '@material-ui/core';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import Alert from '../../common/components/Alert';
import CriteriaForm from '../components/CriteriaForm';
import SearchFormTabs from '../components/SearchFormTabs';
import SearchIDForm from '../components/IDForm';
import SearchNameForm from '../components/SearchNameForm';

import * as searchActions from '../actions';
import classes from '../../css/getCSS';


class SearchForm extends Component {
  componentDidMount() {
    document.title = 'Search Form';
    window.scrollTo(0, 0);
    const type = this.props.match.params.type;  // eslint-disable-line
    if (type === 'by-criteria') {
      this.props.getSearchPreSelection(
        this.props.siteId,
        this.props.token,
        'searchCriteriaForm',
        this.props.searchCriteriaForm,
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const type = this.props.match.params.type;  // eslint-disable-line
    const newType = nextProps.match.params.type;
    if (type !== newType && newType === 'by-criteria') {
      document.title = 'Search Form';
      this.props.onUnmount();
      this.props.getSearchPreSelection(
        this.props.siteId,
        this.props.token,
        'searchCriteriaForm',
        this.props.searchCriteriaForm,
      );
    }
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }


  inputChangedHandler = (event, field) => {
    const type = this.props.match.params.type;  // eslint-disable-line
    let section = null;
    if (type === 'by-criteria') {
      section = 'searchCriteriaForm';
    } else if (type === 'by-id') {
      section = 'searchIDForm';
    } else if (type === 'by-name') {
      section = 'searchNameForm';
    }
    this.props.inputChangedHandler(
      event,
      field,
      section,
      this.props[section],
    );
  }

  submitHandler = (event) => {
    const type = this.props.match.params.type;  // eslint-disable-line
    let section = null;
    if (type === 'by-criteria') {
      section = 'searchCriteriaForm';
    } else if (type === 'by-id') {
      section = 'searchIDForm';
    } else if (type === 'by-name') {
      section = 'searchNameForm';
    }

    this.props.submitHandler(
      event,
      this.props[section],
      this.props.history,
    );
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let form = null;
    if (this.props.match.params.type === 'by-criteria' && !this.props.loading) {
      form = (
        <CriteriaForm
          inputs={this.props.searchCriteriaForm}
          inputChangedHandler={this.inputChangedHandler}
          user={this.props.user}
        />
      );
    }
    if (this.props.match.params.type === 'by-id' && !this.props.loading) {
      form = (
        <SearchIDForm
          inputs={this.props.searchIDForm}
          inputChangedHandler={this.inputChangedHandler}
        />
      );
    }
    if (this.props.match.params.type === 'by-name' && !this.props.loading) {
      form = (
        <SearchNameForm
          inputs={this.props.searchNameForm}
          inputChangedHandler={this.inputChangedHandler}
        />
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="search"
        user={this.props.user}
      >
        <SearchFormTabs
          type={this.props.match.params.type}
        />
        <Paper className={[classes.card].join(' ')} style={{ marginTop: '7px' }}>
          {loading}
          {errorAlert}
          <form method="post" onSubmit={this.submitHandler}>
            {form}
          </form>
        </Paper>
      </DashboardLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.search.loading,
    error: state.search.error,
    searchCriteriaForm: state.search.searchCriteriaForm,
    searchIDForm: state.search.searchIDForm,
    searchNameForm: state.search.searchNameForm,
    siteId: state.common.site.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(searchActions.onUnmount()),
    inputChangedHandler: (event, field, section, inputs) => dispatch(
      searchActions.inputChangedHandler(event, field, section, inputs),
    ),
    getSearchPreSelection: (siteId, token, section, inputs) => dispatch(
      searchActions.getSearchPreSelection(siteId, token, section, inputs),
    ),
    submitHandler: (event, inputs, history) => dispatch(
      searchActions.submitHandler(event, inputs, history),
    ),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchForm));



// WEBPACK FOOTER //
// ./src/search/containers/SearchForm.js